/// <reference path="skyward.ui.reporting.js" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.reportingSorts = skyward.reportingSorts || {};
        var sectionDisplayOnSingleLine = false;

        skyward.reportingSorts.pageBreakOptions =
        {
            True: "True",
            False: "False",
            Burst: "Burst"
        }

        skyward.reportingSorts.editSorts = function (dataLines, sectionData, reportType, allowKeepTogether, calculatedFields)
        {
            let deferred = $.Deferred();
            sectionDisplayOnSingleLine = sectionData.displayOnSingleLine;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetSortEditor",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        reportSorts: skyward.extensions.encodeHtml(JSON.stringify(sectionData.reportSorts)),
                        reportLines: skyward.extensions.encodeHtml(JSON.stringify(dataLines)),
                        prompts: skyward.reporting.prompts.promptCollection.toJsonString(),
                        rootObject: sectionData.rootObject,
                        rootModule: sectionData.rootModule,
                        baseObject: sectionData.baseObject,
                        baseModule: sectionData.baseModule,
                        promptForSortOrder: sectionData.promptForSortOrder,
                        sortPromptGuid: sectionData.sortPromptGuid,
                        sortPromptLabel: skyward.extensions.encodeHtml(sectionData.sortPromptLabel),
                        relationshipPath: sectionData.entireRelationshipPath,
                        reportType: reportType,
                        sectionName: skyward.extensions.encodeHtml(sectionData.displayName),
                        calculatedFieldsJson: JSON.stringify(calculatedFields),
                        allowKeepTogether: allowKeepTogether && !sectionData.displayOnSingleLine
                    }
                }).done(function (data)
                {
                    showPopup(data).done(function (sortData)
                    {
                        deferred.resolve(sortData);
                    });
                });
            return deferred; //Wait for user to finish
        };

        function showPopup(data)
        {
            let html = $(data.html);
            let buttons = [
                { text: "Save", click: confirmEdit, icon: "Save" },
                { text: "Cancel", click: cancelEdit, icon: "Cancel" }
            ];
            let popup = skyward.modalLayer.showDialog("Section Sorts", html, buttons, { closeOnClick: false, draggable: true, automationID: "section-sorts-dialog" });
            let editor = popup.content;
            let editorButtons = {
                moveUp: editor.find('.moveItem.up'),
                moveDown: editor.find('.moveItem.down'),
                add: editor.find('.addItem'),
                remove: editor.find('.removeItem')
            };
            const sortsEditor = editor.find('.reportDefinitionSortsEditor');
            $.when(popup.bodyPromise).then(function ()
            {
                if (data.errors)
                {
                    skyward.validation.displayValidationMessages(data, sortsEditor, null);
                }
            });

            editor.find(".sortItem").on("click", function ()
            {
                var row = $(this);
                var button = row.find(".selectSort");
                selectRow(button);
                setActiveButtonsBasedOnCurrentRow(row);
            });

            var selectedColumns = editor.find(".selectedItemsTable tbody");
            selectedColumns.on('click', '.selectSort', selectItemFromSelectedColumns)
                .on('change', '.pageBreakColumn .pageBreak', togglePageBreak)
                .on('click', '.sortDirectionColumn', toggleDirection)
                .on('click', '.keepTogether', toggleKeepTogether)
                .on('click', '.createBookmark', toggleCreateBookmark)
                .on('click', '.selectSort', removeSelectedItem)
                .on('click', '.sortIconColumn .edit', editFieldNameMode)
                .on('click', '.sortIconColumn .info', getInfoPopup);

            var availableColumns = editor.find(".availableItemsTable tbody");
            availableColumns.on('click', '.selectSort', selectItemFromAvailableColumns)
                .on('click', '.selectSort', addSelectedItem);


            var addPromptForSorts = editor.find(".promptForSortOrder");
            addPromptForSorts.on("change", updatePromptSort);

            editorButtons.add.on('click', addSelectedItem);
            editorButtons.remove.on('click', removeSelectedItem);
            editorButtons.moveUp.on('click', moveSelectedItemUp);
            editorButtons.moveDown.on('click', moveSelectedItemDown);

            var pageBreakContainer = editor.find(".pageBreakColumn .conditionValuesContainer");
            $.each(pageBreakContainer, function (index, container)
            {
                $(container).toggleClass("ui-disabled", sectionDisplayOnSingleLine);
            });

            var waitUntilDoneEditing = $.Deferred().always(function () { popup.close(); });
            return waitUntilDoneEditing;


            // End-of-lifecycle methods
            function cancelEdit()
            {
                waitUntilDoneEditing.reject();
            }

            function confirmEdit()
            {
                skyward.validation.displayValidationMessages(data, sortsEditor, null);

                let sortPromptLabel = editor.find(".sortPromptLabel");
                let sortData =
                {
                    selectedSorts: [],
                    removedSorts: [],
                    sortPrompt:
                    {
                        label: sortPromptLabel.val(),
                        promptGuid: sortPromptLabel.data("sortPromptGuid"),
                        promptForSortOrder: false
                    }
                };

                for (const selectedSort of selectedColumns[0].children)
                {
                    let data = $(selectedSort).data();
                    if (data.hasErrors)
                    {
                        return; // don't allow to save with error sorts
                    }
                    data.friendlyName = selectedSort.dataset.friendlyName; // so jquery doesn't try parsing the name as an object
                    sortData.selectedSorts.push(data);
                }

                availableColumns.children('[data-existing-sort]').each(function ()
                {
                    sortData.removedSorts.push($(this).data());
                });

                if (addPromptForSorts.is(":checked"))
                {
                    sortData.sortPrompt.promptForSortOrder = true;
                }
                waitUntilDoneEditing.resolve(sortData);
            }

            // Interaction methods
            function addSelectedItem()
            {
                if (editorButtons.add.hasClass('ui-disabled'))
                {
                    return;
                }
                var selectedRow = getSelectedRow(editor);
                skyward.svg.swapSvg(selectedRow.find(".addPlus"), "Clear", "BrowseLevel");

                var primaryKeySort = getPrimaryKeyRow(editor);
                if (primaryKeySort.length > 0)
                {
                    selectedRow.insertBefore(primaryKeySort);
                }
                else
                {
                    selectedColumns.append(selectedRow);
                }
                setActiveButtonsBasedOnCurrentRow(selectedRow);
            }

            function removeSelectedItem()
            {
                let selectedRow = getSelectedRow(editor);
                if (editorButtons.remove.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }
                if (selectedRow.data().hasErrors)
                {
                    selectedRow.remove();
                    selectedColumns.trigger('change');
                    let selectedItem = selectRow(selectedColumns.children().first());
                    setActiveButtonsBasedOnCurrentRow(selectedItem);
                    return;
                }

                selectedRow.data("friendlyName", "");
                skyward.svg.swapSvg(selectedRow.find(".clear"), "AddPlus", "BrowseLevel");

                let editFieldTextBox = selectedRow.find(".editField");
                editFieldTextBox.val("");
                selectedRow.find(".fieldNameColumn span").text(editFieldTextBox.attr("placeholder"));
                availableColumns.append(selectedRow);
                setActiveButtons({ add: true });
            }

            function moveSelectedItemUp()
            {
                var selectedRow = getSelectedRow(editor);
                if (editorButtons.moveUp.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }

                var previousRow = selectedRow.prev('.sortItem');
                if (previousRow.length > 0)
                {
                    var isTopItem = previousRow.prev('.sortItem').length === 0;
                    selectedRow.detach().insertBefore(previousRow);
                    setActiveButtons({ remove: true, down: true, up: !isTopItem });
                }
            }

            function moveSelectedItemDown()
            {
                if (editorButtons.moveDown.hasClass('ui-disabled'))
                {
                    return;
                }

                var selectedRow = getSelectedRow(editor);
                var isPrimaryKeySort = selectedRow.data('isPrimaryKeySort');
                var nextRow = selectedRow.next('.sortItem');
                if (nextRow.length > 0 && !nextRow.data('isPrimaryKeySort'))
                {
                    var nextRowNextSortItem = nextRow.next('.sortItem');
                    var isBottomItem = nextRowNextSortItem.length === 0 || nextRowNextSortItem.data('isPrimaryKeySort');
                    selectedRow.detach().insertAfter(nextRow);
                    setActiveButtons({ remove: !isPrimaryKeySort, down: !isBottomItem, up: !isPrimaryKeySort });
                }
            }

            function editFieldNameMode()
            {
                var editButton = $(this);
                var okButton = editButton.siblings(".confirmEdit");
                var cancelButton = editButton.siblings(".cancelEdit");
                var infoButton = editButton.siblings(".info");

                var fieldNameColumn = editButton.parent(".sortIconColumn").siblings(".fieldNameColumn");
                var selectSortButton = fieldNameColumn.find(".selectSort");
                var friendlyNameLabel = fieldNameColumn.find(".friendlyName");
                var fieldNameTextBox = fieldNameColumn.find(".editField");

                var sort = editButton.closest(".sortItem");

                updateEditMode(true);

                okButton.on("click", function ()
                {
                    selectRow(fieldNameTextBox);
                    var friendlyName = fieldNameTextBox.val();
                    if (friendlyName)
                    {
                        var friendlyNameDisplayString = createFriendlyNameDisplay(friendlyName);
                        sort[0].dataset.friendlyName = friendlyNameDisplayString;
                        friendlyNameLabel.text(friendlyNameDisplayString);
                    }
                    else
                    {
                        fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    }
                    updateEditMode(false);
                });

                function createFriendlyNameDisplay(friendlyName)
                {
                    var reversedString = friendlyName.split('').reverse();
                    var numCharsSinceLastSpace = 0;
                    var tempStringArray = [];

                    for (var i = 0; i < reversedString.length && tempStringArray.length <= 90; i++)
                    {
                        var character = reversedString[i];
                        if (character === " ")
                        {
                            numCharsSinceLastSpace = 0;
                        }
                        else
                        {
                            numCharsSinceLastSpace++;
                            if (numCharsSinceLastSpace === 30)
                            {
                                tempStringArray.push(" ");
                                numCharsSinceLastSpace = 0;
                            }
                        }
                        tempStringArray.push(character);
                    }

                    return (tempStringArray.length < friendlyName.length ? "..." : "") + tempStringArray.reverse().join("");
                }

                cancelButton.on("click", function ()
                {
                    fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    selectRow($(this));
                    updateEditMode(false);
                });

                function updateEditMode(enterEditMode)
                {
                    if (enterEditMode)
                    {
                        setActiveButtons({ add: false, up: false, down: false, remove: false });
                    }
                    else
                    {
                        var selectedRow = getSelectedRow(editor);
                        var previousRow = selectedRow.prev('.sortItem');
                        var nextRow = selectedRow.next('.sortItem');
                        var args = {
                            remove: true,
                            down: nextRow.length > 0,
                            up: previousRow.length > 0
                        };
                        setActiveButtons(args);
                    }


                    editButton.toggleClass("hidden", enterEditMode);
                    infoButton.toggleClass("hidden", enterEditMode);
                    selectSortButton.toggleClass("hidden", enterEditMode);
                    friendlyNameLabel.toggleClass("hidden", enterEditMode);
                    okButton.toggleClass("hidden", !enterEditMode);
                    cancelButton.toggleClass("hidden", !enterEditMode);
                    fieldNameTextBox.toggleClass("hidden", !enterEditMode);
                }
            }

            function getInfoPopup()
            {
                var infoButton = $(this);
                var row = selectRow(infoButton);
                var rowData = row.data();

                var iconSpan = $("<span/>");
                var pageBreakText = rowData.pageBreak;

                if (rowData.pageBreakPromptUniqueId)
                {
                    pageBreakText = skyward.reporting.prompts.promptCollection.Get(rowData.pageBreakPromptUniqueId).Label;
                    $.when(skyward.svg.getSvg('DialogPrompt', 'MessageBox')).done(function (svg)
                    {
                        iconSpan.html(svg);
                    });
                }

                var outerDiv = $("<div/>");
                var fieldNameFieldset = buildFieldset().append(buildLabel("title", "Field Name ")).append(buildReadOnlyTextbox("sortInfoPopupLabel", rowData.fieldName));
                var friendlyNameFieldset = buildFieldset().append(buildLabel("title", "Friendly Name ")).append(buildReadOnlyTextbox("sortInfoPopupLabel", rowData.friendlyName));
                var ascendingFieldset = buildFieldset().append(buildLabel("title", "Ascending ")).append(buildReadOnlyTextbox("sortInfoPopupLabel", (!rowData.descending).toString()));
                var pageBreakFieldset = buildFieldset().append(buildLabel("title", "Page Break ")).append(iconSpan.html()).append(buildReadOnlyTextbox("sortInfoPopupLabel", pageBreakText));

                outerDiv.append(fieldNameFieldset).append(friendlyNameFieldset).append(ascendingFieldset).append(pageBreakFieldset);

                skyward.modalLayer.showInformationDialog("Sort Information", outerDiv, null, { anchorTo: infoButton });
            }

            function buildFieldset()
            {
                return $("<fieldset/>");
            }

            function buildLabel(className, text)
            {
                return $("<label/>").text(text).addClass(className);
            }

            function buildReadOnlyTextbox(className, text)
            {
                if (text == "")
                    return;
                return $("<textbox/>", { readonly: "true" }).text(text).addClass(`${className} ui-disabled`);
            }

            function updatePromptSort()
            {
                var checkBox = $(this);
                if (checkBox.is(":checked"))
                {
                    editor.find(".sortPromptLabelFieldset").removeClass("hidden");
                }
                else
                {
                    editor.find(".sortPromptLabelFieldset").addClass("hidden");
                }
                popup.animateModalContents();
            }

            function toggleDirection()
            {
                var row = getParentRow(this);
                var isDesc = row.find('.desc > input').prop('checked');
                row.data("descending", isDesc);
            }

            function toggleKeepTogether()
            {
                var row = getParentRow(this);
                var keepLinesTogether = row.find('.keepTogether').prop('checked');
                row.data("keepLinesTogether", keepLinesTogether);

                if (keepLinesTogether)
                {
                    editor.find('.keepTogether:checked').not(this).each(function (i, e)
                    {
                        getParentRow(e).data("keepLinesTogether", false);
                        $(e).prop('checked', false);
                    });
                }
            }

            function toggleCreateBookmark()
            {
                const row = getParentRow(this);
                const createBookmark = row.find('.createBookmark').prop('checked');
                row.data("createBookmark", createBookmark);
            }

            function togglePageBreak()
            {
                var pageBreakSpan = $(this);
                var data = pageBreakSpan.data();

                var sortItem = getParentRow(this);

                if (data.promptUniqueId)
                {
                    sortItem.data("pageBreak", skyward.reportingSorts.pageBreakOptions.False);
                    sortItem.data("pageBreakPromptUniqueId", data.promptUniqueId);
                }
                else if (data.enumValue)
                {
                    sortItem.data("pageBreakPromptUniqueId", null);
                    sortItem.data("pageBreak", data.enumValue);
                }
            }

            function selectRow(button)
            {
                var row = getParentRow(button);

                var currentSelectedRow = getSelectedRow(editor);
                if (currentSelectedRow.find(".editField").is(":visible"))
                {
                    return currentSelectedRow;
                }
                currentSelectedRow.removeClass("ui-selected");
                row.addClass("ui-selected").focus();
                editor.find('.selectedColumnDataPath').text(row.attr('data-field-name'));
                editor.find('.selectedColumnDataPathLabel').show();
                popup.animateModalContents();
                return row;
            }

            function selectItemFromAvailableColumns()
            {
                selectRow(this);
                setActiveButtons({ add: true });
            }

            function selectItemFromSelectedColumns()
            {
                var selectedItem = selectRow(this);

                setActiveButtonsBasedOnCurrentRow(selectedItem);
            }

            function setActiveButtonsBasedOnCurrentRow(currentRow)
            {
                var isSelectedTable = currentRow.closest(".selectedItemsTable").length > 0;
                var downButtonActive = false;
                var upButtonActive = false;
                var isPrimaryKeySort = currentRow.data('isPrimaryKeySort');

                if (isSelectedTable)
                {
                    var nextItem = currentRow.next('.sortItem');
                    if (nextItem.length > 0 && !nextItem.data('isPrimaryKeySort'))
                    {
                        downButtonActive = true;
                    }

                    var previousItem = currentRow.prev('.sortItem');
                    if (previousItem.length > 0 && !isPrimaryKeySort)
                    {
                        upButtonActive = true;
                    }
                }

                setActiveButtons({ up: upButtonActive, down: downButtonActive, remove: isSelectedTable && !isPrimaryKeySort, add: !isSelectedTable });
            }

            // accepts args = {add: bool, up: bool, down: bool, remove: bool}
            function setActiveButtons(args)
            {
                editorButtons.remove.toggleClass('ui-disabled', !args.remove);
                editorButtons.add.toggleClass('ui-disabled', !args.add);
                editorButtons.moveUp.toggleClass('ui-disabled', !args.up);
                editorButtons.moveDown.toggleClass('ui-disabled', !args.down);
            }
        }

        function getParentRow(button)
        {
            return $(button).closest('tr');
        }

        function getSelectedRow(editor)
        {
            return editor.find('.ui-selected');
        }

        function getPrimaryKeyRow(editor)
        {
            return editor.find('[data-is-primary-key-sort]');
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);
